import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { selectCurrentUser } from '../../selectors/authSelectors';
import { canAuthor } from '../../helpers/userAuth';
import AuthorEditToggle from '../v2/Nav/AuthorEditToggle';
import useLabContext from '../../context/Lab/useLabContext';
import SavingIndicator from '../Utils/SavingIndicator';
import AuthorViewLearning3kLab from '../v2/Nav/AuthorViewLearning3kLab';

export default function LabToolbar({ assignmentId: assignmentId, tutorialId: tutorialId }) {
  const currentUser = useSelector(selectCurrentUser);
  const { isEditMode } = useLabContext();

  const showEditToggle = canAuthor(currentUser);

  const renderToolbar = () => {
    return (
      <div className={classnames('lab-tools lab-tools--opened')}>
        <div className="lab-tools__wrapper">
          <div className="lab-tools__open">
            {showEditToggle && (
              <>
                {isEditMode && (
                  <div className="edit-mode__saving-indicator">
                    <SavingIndicator />
                  </div>
                )}
                <AuthorEditToggle />
                {assignmentId && <AuthorViewLearning3kLab id={assignmentId} type="assignment" />}
                {tutorialId && <AuthorViewLearning3kLab id={tutorialId} type="tutorial" />}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  return renderToolbar();
}
